import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.tsx";
import { initTheme } from "./state/theme.ts";
import { initConsent } from "./state/consent.ts";
import { installFlushOnHide } from "./analytics.ts";
import { installNetworkListeners } from "./state/network.ts";
import { useGame } from "./state/game.ts";
import { captureAttribution } from "./attribution.ts";
import "./styles/app.css";

captureAttribution();
// Modo captura de reels: __CAPTURE__ es false en cualquier build normal y el
// import desaparece del bundle (scripts/check-no-capture.mjs lo comprueba).
if (__CAPTURE__) (await import("./capture/capture.ts")).installCapture();
initTheme();
initConsent();
installFlushOnHide();
// Al recuperar la conexión, se reintenta la carga si había fallado.
installNetworkListeners(() => {
  const game = useGame.getState();
  if (game.error || !game.round) void game.load();
});

const root = document.getElementById("root");
if (!root) throw new Error("No se encontró #root");
createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
